import api from './api';

export const roomService = {
  // Get all rooms — supports ?status=&min_price=&max_price=&capacity=
  getAllRooms: async (params = {}) => {
    return await api.get('/rooms', { params });
  },

  // Get only available rooms
  getAvailableRooms: async () => {
    return await api.get('/rooms', { params: { status: 'available' } });
  },

  // Check room availability for a date range
  checkAvailability: async (roomId, checkIn, checkOut) => {
    return await api.get(`/rooms/${roomId}/availability`, {
      params: { check_in: checkIn, check_out: checkOut },
    });
  },

  // Get room by ID
  getRoomById: async (roomId) => {
    return await api.get(`/rooms/${roomId}`);
  },

  // Create room (owner only)
  createRoom: async (roomData) => {
    return await api.post('/rooms', roomData);
  },

  // Update room (owner only)
  updateRoom: async (roomId, roomData) => {
    return await api.put(`/rooms/${roomId}`, roomData);
  },

  // Delete room (owner only)
  deleteRoom: async (roomId) => {
    return await api.delete(`/rooms/${roomId}`);
  },
};